import container from 'di/inversify.config';
import { NetworkServiceInterface } from '@collaborator/npm_modules/dist/components/NetworkService';
import TYPES from 'di/types';

const useNetworkService = () => container.get<NetworkServiceInterface>(TYPES.NetworkService);

export { useNetworkService };
